import { configureStore } from "@reduxjs/toolkit";
import homeSlice from "../screens/home/homeSlice";
import blogSlice from "../screens/blog/blogSlice";
import contactSlice from "../screens/contact/contactSlice";
import weddingSlice from "../screens/wedding/weddingSlice";
import propertySlice from "../screens/property/propertySlice";
import packageSlice from "../screens/package/packageSlice";
import attractionSlice from "../screens/attraction/attractionSlice";
import careerSlice from "../screens/career/careerSlice";

export const makeStore = () =>
  configureStore({
    reducer: {
      home: homeSlice,
      blog: blogSlice,
      contact: contactSlice,
      wedding: weddingSlice,
      property: propertySlice,
      package: packageSlice,
      attraction: attractionSlice,
      career: careerSlice,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  });

// Infer types from the factory function
export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
